import classnames from 'classnames';
import React, { useEffect, useRef } from 'react';
import CertificationPopup from '../certification/CertificationPopup/CertificationPopup';
import './ProductCertifications.scss';
interface ProductCertificationsProps {
  certificationsGroup: {
    [key: string]: { description: string; url: string; source: string; sourceTitle: string; type: string; sku: string; files?: boolean }[];
  };
  openIndex: number | null;
  setOpenIndex: (val: number) => void;
  type?: string;
  productTitle?: string;
}

export default function ProductCertificationsItems(props: ProductCertificationsProps): React.ReactElement {
  const { certificationsGroup, openIndex, setOpenIndex, type, productTitle } = props;
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setOpenIndex(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popupRef, setOpenIndex]);

  return (
    <div className="product-certifications__items">
      {Object.entries(certificationsGroup).map(([name, certs], index) => (
        <span key={index}>
          <button
            className={classnames('product-certifications__item', { 'product-certifications__item--selected': openIndex === index })}
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
          >
            {name}
          </button>
          {openIndex === index && (
            <div ref={popupRef}>
              <CertificationPopup
                name={name}
                description={certs[0].description}
                urls={certs.map((c) => c.url)}
                source={certs[0].source}
                sourceTitle={certs[0].sourceTitle}
                type={certs[0].type || type}
                sku={certs.map((c) => c.sku).join(', ')}
                files={certs[0].files}
                productTitle={productTitle}
              />
            </div>
          )}
        </span>
      ))}
    </div>
  );
}
